const JST_OFFSET_HOURS = 9;
const DAY_BOUNDARY_HOUR = 4;

const pad2 = (n: number) => String(n).padStart(2, "0");

export function formatDateKey(d: Date): string {
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

export function getEffectiveDate(now = new Date()): Date {
  const jstMs = now.getTime() + JST_OFFSET_HOURS * 60 * 60 * 1000;
  const effectiveMs = jstMs - DAY_BOUNDARY_HOUR * 60 * 60 * 1000;
  return new Date(effectiveMs);
}

export function getTodayKey(now = new Date()): string {
  return formatDateKey(getEffectiveDate(now));
}

export function addDaysToKey(dateKey: string, days: number): string {
  const [year, month, day] = dateKey.split("-").map(Number);
  const d = new Date(Date.UTC(year, month - 1, day));
  d.setUTCDate(d.getUTCDate() + days);
  return formatDateKey(d);
}

export function getShortDate(dateKey: string): string {
  const [, month, day] = dateKey.split("-");
  return `${Number(month)}/${Number(day)}`;
}
